import { action, makeObservable, observable, runInAction } from 'mobx';
import { ApiError, BusinessMembership, LeaveBusinessResult } from '../../types';
import { businessService } from '../../services';

export class MembershipStore {
  members: BusinessMembership[] = [];
  loading = false;
  mutating = false;
  leaving = false;
  error: ApiError | null = null;

  constructor() {
    makeObservable(this, {
      members: observable,
      loading: observable,
      mutating: observable,
      leaving: observable,
      error: observable,
      loadMembers: action,
      removeMember: action,
      leave: action,
      clear: action,
    });
  }

  async loadMembers(): Promise<void> {
    this.loading = true;
    this.error = null;
    try {
      const list = await businessService.listMembers();
      runInAction(() => {
        this.members = list;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err as ApiError;
      });
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  }

  async removeMember(userId: string): Promise<void> {
    this.mutating = true;
    this.error = null;
    try {
      await businessService.removeMember(userId);
      runInAction(() => {
        this.members = this.members.filter((m) => m.userId !== userId);
      });
    } catch (err) {
      runInAction(() => {
        this.error = err as ApiError;
      });
      throw err;
    } finally {
      runInAction(() => {
        this.mutating = false;
      });
    }
  }

  async leave(): Promise<LeaveBusinessResult> {
    this.leaving = true;
    this.error = null;
    try {
      return await businessService.leave();
    } catch (err) {
      runInAction(() => {
        this.error = err as ApiError;
      });
      throw err;
    } finally {
      runInAction(() => {
        this.leaving = false;
      });
    }
  }

  clear(): void {
    this.members = [];
    this.error = null;
  }
}
